import { type IJsonQueryRangeValue } from '@/packages/api-models/common/json_query';

export function getRangeText(range: IJsonQueryRangeValue | null): string {
  const { gte = null, lte = null } = range || {};

  return [gte != null && `от ${gte}`, lte != null && `до ${lte}`].filter(Boolean).join(' ');
}
